import { toast } from 'react-toastify';
import apiCliente from 'utils/apiCliente';

let request, url, body;

export const quitarPackCarrito = async (clienteId, productoId, cantidad, token) => {
	request = '/carrito/quitarPackCarrito';
	url = `${request}`;

	body = {
		userId: clienteId,
		productoId: productoId,
		cantidad: cantidad,
	};

	try {
		const response = await apiCliente.post(url, body, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});

		return response.data;
	} catch (error) {
		if (error.response) {
			if (error.response.status === 401) {
				toast.info('Su sesión ha expirado. Por favor, inicie sesión nuevamente.', {
					onClose: () => {
						window.location.href = '/login';
					},
				});
			} else {
				const errorData = error.response.data;
				throw new Error(errorData.error || 'Se produjo un error desconocido.');
			}
		} else if (error.request) {
			throw new Error('No se pudo establecer conexión con el servidor.');
		} else {
			throw new Error('Error al realizar la solicitud.');
		}
	}
};
